export interface DashboardLoadingStateProps {
  text?: string;
}

/** CSS spinner — DevExtreme LoadIndicator on first paint can hit React #185 under React 19. */
export function DashboardLoadingState({ text = 'Loading dashboard...' }: DashboardLoadingStateProps) {
  return (
    <div className="dashboard-loading" role="status" aria-live="polite">
      <div className="dashboard-loading-spinner" aria-hidden />
      <p className="dashboard-loading-text">{text}</p>
    </div>
  );
}
